export default function Technology() {
  const techStack = [
    { name: 'Next.js', icon: 'ri-pages-line', color: 'text-slate-900' },
    { name: 'NestJS', icon: 'ri-server-line', color: 'text-red-600' },
    { name: 'PostgreSQL', icon: 'ri-database-2-line', color: 'text-blue-600' },
    { name: 'Prisma', icon: 'ri-stack-line', color: 'text-slate-700' },
    { name: 'TypeScript', icon: 'ri-code-s-slash-line', color: 'text-blue-500' },
    { name: 'React', icon: 'ri-reactjs-line', color: 'text-cyan-500' },
    { name: 'OpenAI', icon: 'ri-brain-line', color: 'text-green-600' },
    { name: 'Gemini', icon: 'ri-sparkling-line', color: 'text-purple-600' },
    { name: 'LangChain', icon: 'ri-links-line', color: 'text-orange-600' },
    { name: 'Stripe', icon: 'ri-bank-card-line', color: 'text-indigo-600' },
    { name: 'WebRTC', icon: 'ri-video-line', color: 'text-teal-600' },
    { name: 'AWS', icon: 'ri-cloud-line', color: 'text-yellow-600' }
  ];

  return (
    <section className="scroll-animate py-36 bg-gradient-to-b from-white via-blue-50/30 to-white relative overflow-hidden">
      {/* Background gradient mesh */}
      <div className="absolute inset-0 opacity-40">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-300 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-20">
        <div className="flex items-center gap-20">
          {/* Left 40%: Text content */}
          <div className="w-2/5">
            <h2 className="text-5xl font-bold text-slate-900 mb-8">
              Built with<br />Cutting-Edge Tech
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-10">
              We leverage the latest technologies to build scalable, secure, and intelligent platforms. Our tech stack combines proven frameworks with cutting-edge AI to deliver exceptional performance.
            </p>
            
            {/* 3 Badges */}
            <div className="space-y-4">
              <div className="flex items-center gap-4 bg-white rounded-xl p-4 shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg">
                  <i className="ri-brain-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <div className="font-semibold text-slate-900">AI-Powered</div>
                  <div className="text-sm text-slate-600">Advanced machine learning</div>
                </div>
              </div>
              
              <div className="flex items-center gap-4 bg-white rounded-xl p-4 shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-global-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <div className="font-semibold text-slate-900">Global Scale</div>
                  <div className="text-sm text-slate-600">Multi-region infrastructure</div>
                </div>
              </div>
              
              <div className="flex items-center gap-4 bg-white rounded-xl p-4 shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg">
                  <i className="ri-flashlight-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <div className="font-semibold text-slate-900">Lightning Fast</div>
                  <div className="text-sm text-slate-600">Optimized performance</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right 60%: Tech stack visual */}
          <div className="w-3/5 relative">
            <div className="relative w-full h-[500px] flex items-center justify-center">
              {/* Hexagon grid with tech logos */}
              <div className="relative w-full h-full animate-float-slow">
                {techStack.map((tech, index) => {
                  const angle = (index * 360) / techStack.length;
                  const radius = 180;
                  const x = Math.cos((angle * Math.PI) / 180) * radius;
                  const y = Math.sin((angle * Math.PI) / 180) * radius;
                  
                  return (
                    <div
                      key={index}
                      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all duration-300 hover:scale-125 cursor-pointer"
                      style={{
                        transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
                        animationDelay: `${index * 0.1}s`
                      }}
                    >
                      <div className="relative group">
                        {/* Hexagon shape */}
                        <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex flex-col items-center justify-center gap-2 border-2 border-slate-100 hover:border-blue-300 transition-all duration-300">
                          <i className={`${tech.icon} text-3xl ${tech.color}`}></i>
                          <span className="text-xs font-medium text-slate-700">{tech.name}</span>
                        </div>
                        
                        {/* Connection lines */}
                        {index < techStack.length - 1 && (
                          <div className="absolute top-1/2 left-1/2 w-32 h-0.5 bg-gradient-to-r from-blue-300 to-transparent opacity-30 origin-left"
                            style={{
                              transform: `rotate(${angle + 30}deg)`
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  );
                })}
                
                {/* Center circle */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl">
                  <div className="text-center text-white">
                    <i className="ri-code-box-line text-4xl mb-1"></i>
                    <div className="text-xs font-semibold">Tech Stack</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
